document.addEventListener('DOMContentLoaded', () => {
  // Initialize Reviews Images Carousel (Variable-width, free scrolling)
  const reviewsImagesEmblaNode = document.querySelector('.embla--reviews-images');
  if (reviewsImagesEmblaNode) {
    const reviewsImagesEmbla = EmblaCarousel(reviewsImagesEmblaNode, {
      loop: true,
      align: 'start',
      containScroll: false,
      slidesToScroll: 1,
      dragFree: true,
      breakpoints: { 
        '(max-width: 768px)': { 
          containScroll: 'keepSnaps',
          slidesToShow: 1,
          dragFree: false 
        } 
      }
    });
    const prevButtonReviews = document.querySelector('.embla__prev--reviews-images');
    const nextButtonReviews = document.querySelector('.embla__next--reviews-images');
    prevButtonReviews.addEventListener('click', () => reviewsImagesEmbla.scrollPrev());
    nextButtonReviews.addEventListener('click', () => reviewsImagesEmbla.scrollNext());
  }

  // Initialize Memes Carousel (Variable-width, free scrolling)
  const memesEmblaNode = document.querySelector('.embla--memes');
  if (memesEmblaNode) {
    const memesEmbla = EmblaCarousel(memesEmblaNode, {
      loop: true,
      align: 'start',
      containScroll: false,
      slidesToScroll: 1,
      dragFree: true,
      breakpoints: { 
        '(max-width: 768px)': { 
          containScroll: 'keepSnaps',
          slidesToShow: 1,
          dragFree: false 
        } 
      }
    });
    const prevButtonMemes = document.querySelector('.embla__prev--memes');
    const nextButtonMemes = document.querySelector('.embla__next--memes');
    prevButtonMemes.addEventListener('click', () => memesEmbla.scrollPrev());
    nextButtonMemes.addEventListener('click', () => memesEmbla.scrollNext());
  }
});